import type { JobChecklist } from "../types";

/** Derives completed/total counts without storing a second source of truth. */
export function checklistCounts(checklists: readonly JobChecklist[]): {
	completed: number;
	total: number;
} {
	let completed = 0;
	let total = 0;
	for (const checklist of checklists) {
		total += checklist.items.length;
		completed += checklist.items.filter((item) => item.completed).length;
	}
	return { completed, total };
}

/** Started rows need descriptions; due dates remain optional calendar dates. */
export function validateChecklists(
	checklists: readonly JobChecklist[],
): string {
	for (const [index, checklist] of checklists.entries()) {
		for (const [itemIndex, item] of checklist.items.entries()) {
			if (!item.description.trim())
				return `Checklist ${index + 1}, item ${itemIndex + 1} needs a description, or remove it.`;
			if (
				item.dueOn &&
				(!/^\d{4}-\d{2}-\d{2}$/.test(item.dueOn) ||
					!Number.isFinite(Date.parse(`${item.dueOn}T00:00:00Z`)) ||
					new Date(`${item.dueOn}T00:00:00Z`).toISOString().slice(0, 10) !==
						item.dueOn)
			) {
				return `Checklist ${index + 1}, item ${itemIndex + 1} needs a valid due date.`;
			}
		}
	}
	return "";
}
